import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";

var _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", null, "vuecmf-editor demo", -1);

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_vuecmf_editor = _resolveComponent("vuecmf-editor");

  return _openBlock(), _createElementBlock(_Fragment, null, [_hoisted_1, _createVNode(_component_vuecmf_editor, {
    id: "myeditor",
    content: _ctx.contentHtml,
    onOnChange: _ctx.getContent
  }, null, 8, ["content", "onOnChange"]), _createElementVNode("button", {
    onClick: _cache[0] || (_cache[0] = //@ts-ignore
    function () {
      return _ctx.save && _ctx.save.apply(_ctx, arguments);
    })
  }, "保存")], 64);
}